/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const renameScheduleBodyExpectedVersionExclusiveMin = 0;
export const renameScheduleBodyExpectedVersionMax = 9007199254740991;

export const RenameScheduleBody = zod.object({
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  timeZone: zod.unknown().optional(),
  name: zod.string(),
  expectedVersion: zod
    .int()
    .gt(renameScheduleBodyExpectedVersionExclusiveMin)
    .max(renameScheduleBodyExpectedVersionMax),
});

export type RenameScheduleBody = zod.input<typeof RenameScheduleBody>;
export type RenameScheduleBodyOutput = zod.output<typeof RenameScheduleBody>;
